import React from 'react';

export const AcceptBtn = props => {
    return (
        <button className={`acceptButton button ${props.extraClasses}`} onClick={props.onclick}>
            {props.title}
        </button>
    );
};

export const CancelBtn = props => {
    return (
        <button className={`cancelButton button ${props.extraClasses}`} onClick={props.onclick}>
            {props.title}
        </button>
    );
};




// WEBPACK FOOTER //
// ./src/customModules/Common/NotificationButtons.js